import(/* webpackMode: "eager" */ "/app/src/app/[[...id]]/error.tsx")